import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Http from "../../services/Http";
import QueryParams from "../../services/QueryParams";
import Storage from "../../services/Storage";
import "./Login.scss";

const SessionChecker = () => {

    const [http] = useState(new Http());
    const [storage] = useState(new Storage());
    const [queryParams] = useState(new QueryParams());
    const [token, setToken] = useState(storage.token() || "");
    const history = useHistory();

    const redirect = useCallback((forbidden?) => {
        if (forbidden) {
            window.location.href = "";
        } else {
            if (queryParams.get("returnTo")) {
                window.location.href = queryParams.get("returnTo");
            } else {
                window.location.href = `${process.env.REACT_APP_IEC_ID_URL}`;
            }
        }
    }, [queryParams]);

    window.addEventListener("storage", function (e: any) {
        console.log(e);
        if (storage.token()) {
            setToken(storage.token() || "");
        } else {
            setToken("");
        }
    });

    console.log("checking...");

    const handleError = useCallback((resp: any) => {
        switch (resp.status) {
            case 401:
                storage.remove("sso_token");
                setToken("");
                break;

            case 403:
                redirect(true);
                break;

            default:
                toast.info(resp.data.message);
                break;
        }
    }, [redirect, storage]);

    useEffect(() => {
        if (token) {
            http.secureGet(`mock`)
                .then((resp: any) => {
                    if (resp.status === 200) {
                        redirect();
                    } else {
                        handleError(resp);
                    }
                })
                .catch((error: any) => {
                    if (error.response) {
                        handleError(error.response);
                    } else {
                        toast.error("Something went wrong!");
                    }
                });
        } else {
            history.push("/login");
        }
    }, [handleError, history, http, redirect, token]);

    return (
        <div className="global-container bg-gradient">
            <div className="tweak">
                <div className="container text-center text-white">
                    <h5>Checking session...</h5>
                </div>
            </div>
        </div>
    )
}

export default SessionChecker;